module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "login-headerBack",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-headerHome"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "login-contentForm"
  }, [_c('div', {
    staticClass: "login-contentUserName"
  }, [_c('label', {
    attrs: {
      "for": "userName"
    }
  }, [_vm._v("账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userName),
      expression: "userName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "userName",
      "placeholder": "请输入手机号/邮箱"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-contentPassword"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('Icon', {
    staticClass: "login-contentPassword-eye",
    attrs: {
      "type": "ios-eye-outline",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "login-contentAuthCode"
  }, [_c('label', {
    attrs: {
      "for": "authCode"
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.authCode),
      expression: "authCode",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "authCode"
    },
    domProps: {
      "value": (_vm.authCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authCode = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('span', {
    staticClass: "login-contentChangeCode"
  }, [_vm._v("换一换")])]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "errorTxt"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "login-contentOtherOption"
  }, [_c('a', {
    staticClass: "login-forgetPsw",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": "/register"
    }
  }, [_c('a', {
    staticClass: "login-register",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v(" 注册 ")])])], 1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-headerTitle"
  }, [_c('span', [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-contentLoginBtn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-contentTip"
  }, [_c('p', [_vm._v("点击上面“登录”按钮")]), _vm._v(" "), _c('p', [_vm._v("即表示您同意"), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("《阿里文学用户服务协议》")]), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("《隐私服务协议》")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-ce059552","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/login/index.vue
// module id = 196
// module chunks = 1